import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { of } from 'rxjs';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { UtilsService } from './../_services/utils.service';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "@angular/router";
import * as i3 from "../_services/utils.service";
var CashierService = /** @class */ (function () {
    function CashierService(http, router, _utilsService) {
        this.http = http;
        this.router = router;
        this._utilsService = _utilsService;
        this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
        if (this.currentUser != null) {
            this.user_id = this.currentUser.id;
        }
    }
    CashierService.prototype.cashierTickets = function (oauth_token, user_id) {
        return this._utilsService.getRequest("" + environment.phpApiUrl + '/tournament/cashier-tickets/' + oauth_token + '/' + user_id);
    };
    CashierService.prototype.userData = function (oauth_token, user_id) {
        return this._utilsService.getRequest("" + environment.phpApiUrl + '/user/profile/' + oauth_token + '?page=cashier');
    };
    CashierService.prototype.summaryInfo = function (user_id) {
        return this._utilsService.getRequest("" + environment.phpApiUrl + '/cashier/summary/' + ("" + environment.DRAFT_ACCESS_TOKEN) + '/' + user_id);
    };
    CashierService.prototype.addFunds = function (user_id) {
        return this._utilsService.getRequest("" + environment.phpApiUrl + '/cashier/add-funds/' + ("" + environment.DRAFT_ACCESS_TOKEN) + '/' + user_id);
    };
    CashierService.prototype.accountHistory = function (user_id, txn_action, cursor) {
        return this._utilsService.getRequest("" + environment.phpApiUrl + '/wallet/get-all/' + ("" + environment.DRAFT_ACCESS_TOKEN) + '/' + user_id + '/' + txn_action + '/' + cursor + '/' + 20);
    };
    CashierService.prototype.getTickets = function (user_id) {
        return this._utilsService.getRequest("" + environment.phpApiUrl + '/tournament/cashier-tickets/' + ("" + environment.DRAFT_ACCESS_TOKEN) + '/' + user_id);
    };
    CashierService.prototype.pendingCashOut = function (user_id) {
        return this._utilsService.getRequest("" + environment.phpApiUrl + '/wallet/get-pending-item/' + ("" + environment.DRAFT_ACCESS_TOKEN) + '/' + user_id);
    };
    CashierService.prototype.stateList = function (country_id) {
        return this._utilsService.getRequest("" + environment.phpApiUrl + '/location/getStatesByCountry/' + ("" + environment.DRAFT_ACCESS_TOKEN) + '/' + country_id);
    };
    CashierService.prototype.deleteCashOutRequest = function (data) {
        return this._utilsService.postRequest("" + environment.phpApiUrl + '/cashier/cancel-request', data, null, 'content-type-json');
    };
    CashierService.prototype.confirmCashOut = function (data) {
        return this._utilsService.postRequest("" + environment.phpApiUrl + '/cashier/cashout-confirm', data, null, 'content-type-json');
    };
    CashierService.prototype.checkPromoCode = function (data) {
        return this._utilsService.postRequest("" + environment.phpApiUrl + '/cashier/check-promo-code', data, null, 'content-type-json');
    };
    CashierService.prototype.checkPromoCodeByAmt = function (data) {
        return this._utilsService.postRequest("" + environment.phpApiUrl + '/promocode/check', data, null, 'content-type-json');
    };
    CashierService.prototype.validatePaypal = function (data) {
        return this._utilsService.postRequest("" + environment.phpApiUrl + '/payment/validatePaypal', data, null, 'content-type-json');
    };
    CashierService.prototype.savedCards = function (user_id) {
        return this._utilsService.getRequest("" + environment.phpApiUrl + '/cashier/saved-cards/' + ("" + environment.DRAFT_ACCESS_TOKEN) + '/' + user_id);
    };
    CashierService.prototype.deleteCards = function (data) {
        return this._utilsService.postRequest("" + environment.phpApiUrl + '/cashier/delete-cards', data, null, 'content-type-json');
    };
    CashierService.prototype.addNewCard = function (data) {
        return this._utilsService.postRequest("" + environment.phpApiUrl + '/cashier/add-new-cards', data, null, 'content-type-json');
    };
    CashierService.prototype.tsevoVerification = function (data) {
        return this._utilsService.postRequest("" + environment.phpApiUrl + '/cashier/tsevo_verification', data, null, 'content-type-json');
    };
    CashierService.prototype.submitVerificationDocument = function (data) {
        return this._utilsService.postRequest("" + environment.adminUrl + '/cashierPopup/submit-verification-document', data, null);
    };
    CashierService.prototype.checkPaypalPaymentStatus = function (payment_id) {
        return this._utilsService.getRequest("" + environment.phpApiUrl + '/payment/check-paypal-payment-status/' + ("" + environment.DRAFT_ACCESS_TOKEN) + '/' + payment_id);
    };
    CashierService.prototype.checkUserEligibility = function (data) {
        return this._utilsService.postRequest("" + environment.phpApiUrl + '/user/checkUserEligibility', data, null, 'content-type-json');
    };
    CashierService.prototype.getFinancialReport = function (user_id, year) {
        var data = { 'user_id': user_id, 'year': year };
        return this._utilsService.postRequest("" + environment.phpApiUrl + '/wallet/get-financial-report', data, null, 'content-type-json');
    };
    CashierService.prototype.handleError = function (error) {
        console.error('server error:', error);
        if (error.error instanceof Error) {
            var errMessage = error.error.message;
            return Observable.throw(errMessage);
        }
        return Observable.throw(error || 'Socket.io server error');
    };
    CashierService.prototype.handleErrorPost = function (operation, result) {
        if (operation === void 0) { operation = 'operation'; }
        return function (error) {
            // TODO: send the error to remote logging infrastructure
            console.error(error); // log to console instead
            // TODO: better job of transforming error for user consumption
            console.log(operation + " failed: " + error.message);
            // Let the app keep running by returning an empty result.
            return of(result);
        };
    };
    CashierService.prototype.sendPhoneOtp = function (phoneNumber) {
        var data = phoneNumber ? { phone_number: phoneNumber } : {};
        return this._utilsService.postRequest(environment.phpApiUrl + "/user/triggerPhoneOtp", data, null);
    };
    CashierService.prototype.kycVerification = function () {
        return this._utilsService.getRequest("" + environment.phpApiUrl + '/user/kyc-verification');
    };
    CashierService.prototype.verficationInfo = function () {
        var url = environment.phpApiUrl + "/user/profile/" + environment.DRAFT_ACCESS_TOKEN + "?page=verification";
        return this._utilsService.getRequest(url);
    };
    CashierService.ngInjectableDef = i0.defineInjectable({ factory: function CashierService_Factory() { return new CashierService(i0.inject(i1.HttpClient), i0.inject(i2.Router), i0.inject(i3.UtilsService)); }, token: CashierService, providedIn: "root" });
    return CashierService;
}());
export { CashierService };
